import * as React from "react";

export class Arrow extends React.Component<{
    text: string | JSX.Element
    classModifier?: string
    handler: Function | any
}, {}> {
    baseClass: string

    constructor(props) {
        super(props);
        this.baseClass = "rj-racing-next-races__arrow";
    }

    render() {
        let cls = `${this.baseClass}${(this.props.classModifier ? ` ${this.baseClass}--${this.props.classModifier}` : "")}`
        return (
            <div onClick={this.props.handler} className={cls}>{this.props.text}</div>
        )
    }
}